import {AvailabilityOptions} from './base.model';

export const URL_PART_LIVE = 'store';
// Name of the backend "house" company that holds client-less orders (mirrors idcarms
// noClientCompanyName). An order on this company is treated as "client not configured".
export const NO_CLIENT_COMPANY_NAME = 'Без клиента';
export const PERM_READ = 'readonly';
export const PERM_WRITE = 'readwrite';
export const DB_VERSION = 1;
export const OFFLINE_ON = false;
export const DAYS_TO_SHOW = 7;
// A change to an order publishes one notification per line (closing, reopening, «в работе»), so the order list
// and the order page wait this long after the last one before reading again.
export const SOCKET_REFRESH_DEBOUNCE_MS = 300;
// ...but no longer than this after the first one: notifications that never pause (lines created on other orders)
// would otherwise put the read off for as long as they last.
export const SOCKET_REFRESH_MAX_WAIT_MS = 2000;
// A failed read the order page made on a notification is tried again after each of these delays, silently, then
// given up until the next notification or read.
export const SOCKET_REFRESH_RETRY_DELAYS_MS = [1000, 3000];

// JSON-RPC error code SHOP_INVOICE_REVISION_CONFLICT (idcarms Supply range 1300-1399):
// setInvoiceProcessed was called with an expectedRevisedAt that no longer matches the stored one,
// i.e. the supplier reissued the invoice after the page loaded and the write was refused. Lives
// here because two places must agree on it — the toast in ErrorHandlingService and the outcome
// SupplyService reports to the invoice page (which reloads instead of retrying).
// Since 2026-09-30 an un-approval also gets it on its expectedApprovalGeneration: a stale one
// means the invoice was approved again after the page loaded; a missing or null one means the tab
// was loaded before the panel sent the key, which only F5 cures — reloading the invoice does not.
export const ERROR_SHOP_INVOICE_REVISION_CONFLICT = 1340;

// JSON-RPC error code MATCH_STATE_CHANGED (idcarms Accounting.Error): createMatches was built on a state of
// the waybill that has since changed, and inserted nothing — either the waybill's productsVersion is no longer
// the one the batch carries (any line of the waybill changed), or the batch's lines no longer have exactly
// the active matches it expected. Shared by the toast
// in ErrorHandlingService, which stays silent for it, and the «Вся накладная» page and the per-line screen,
// which reload the waybill and then say so themselves.
export const ERROR_MATCH_STATE_CHANGED = 1222;

// JSON-RPC error code ORDER_CLIENT_CHANGED (idcarms SuplStore.Error): the order's stored client is no longer
// the one the writer saw, and nothing was written — setOrderClient found the order no longer on the house
// company «Без клиента», or updateOrder found a client other than its expectedCompanyID. Someone, or an
// earlier call whose answer was lost, changed it. Shared by the toast in ErrorHandlingService, which stays
// silent for it, and the screens that set the client, which re-read the order and then say so themselves.
export const ERROR_ORDER_CLIENT_CHANGED = 1010;

// JSON-RPC error code ORDER_CAR_NOT_OF_CLIENT (idcarms SuplStore.Error): setOrderClient found a position of
// the order, closed and deleted ones included, with a car, or a complaint on a car, of another company, and
// wrote nothing. Shared like ERROR_ORDER_CLIENT_CHANGED: the toast stays silent, the screen says so itself.
export const ERROR_ORDER_CAR_NOT_OF_CLIENT = 1011;

// JSON-RPC error code CAR_NOT_FOUND (idcarms Car.Error): the car is linked to no client, or names no car.
export const ERROR_CAR_NOT_FOUND = 300;

// JSON-RPC error code CAR_CHANGED (idcarms Car.Error): updateCompanyCarInfo found the car's updatedAt other than
// the expectedUpdatedAt the edit carried, and wrote nothing. Shared by the toast in ErrorHandlingService, which
// stays silent for it, and the car dialog, which rereads the car and then says so itself.
export const ERROR_CAR_CHANGED = 304;

// JSON-RPC error codes WAYBILL_NOT_FOUND and WAYBILL_DELETED (idcarms Accounting.Error): createMatches
// checks the waybill before its state, so a deleted waybill is never reported as 1222.
export const ERROR_WAYBILL_NOT_FOUND = 1200;
export const ERROR_WAYBILL_DELETED = 1202;

export const enum IDBInstances {
    USER = 'user',
    SHOP = 'shop'
}

export const enum IDBStorages {
    USERS = 'users',
    SHOPS = 'shops'
}

export const enum IDBMetadataIndexes {
    SYNC = 'sync_idx',
    TRACING_ID = 'tracing_id_idx',
    REAL_ID = 'real_id_idx'
}

export const enum JSONRPCMethods {
}

export const METHODS_TO_QUEUE = [
    '',
];

// FIXME: Delete after state service is implemented
export const enum EventSW {
    SYNC_IS_STARTED = 'SYNC_IS_STARTED',
    SYNC_IS_COMPLETED = 'SYNC_IS_COMPLETED'
}

export const enum SocketEvents {
    CONNECT = 'connect',
    RECONNECT = 'reconnect',
    DISCONNECT = 'disconnect',
    ERROR = 'error',
    CONNECT_ERROR = 'connect_error',
    RECONNECT_ERROR = 'reconnect_error',
    SUBSCRIBE = 'subscribe',
    PART_SEARCH_CREATED = 'sparepart_search_created',
    PART_SEARCH_STARTED = 'sparepart_search_started',
    PART_SEARCH_FINISHED = 'sparepart_search_finished',
    CHAT_UPDATED = 'chat_updated',
    NEW_SUPL_REQUEST = 'new_suplrequest',
    NEW_HIDDEN_SUPL_REQUEST = 'new_hidden_suplrequest',
    UPDATED_SUPL_REQUEST = 'updated_suplrequest',
    CLOSED_SUPL_REQUEST = 'closed_suplrequest',
    REOPENED_SUPL_REQUEST = 'reopened_suplrequest',
    DELETED_SUPL_REQUEST = 'deleted_suplrequest',
    SHIPPED_SUPL_REQUEST = 'suplrequest_shipped',
    NEW_SUPL_REQUEST_PROPOSAL = 'new_suplrequest_proposal',
    UPDATED_SUPL_REQUEST_PROPOSAL = 'updated_suplrequest_proposal',
    APPROVED_SUPL_REQUEST_PROPOSAL = 'approved_suplrequest_proposal',
    DISAPPROVED_SUPL_REQUEST_PROPOSAL = 'disapproved_suplrequest_proposal'
}

export const enum LocalStorageSeenDataFields {
    REQUEST = 'lastSeenRequestAt',
    CHAT = 'lastSeenChatAt'
}

export const enum SuplRequestFilterOptions {
    ALL = 'all',
    NEW = 'new',
    UNSEEN = 'unseen',
    UNSEEN_CHATS = 'unseen_chats',
    ANSWERED = 'answered',
    UNANSWERED = 'unanswered',
    SHIPPED = 'shipped',
    TO_SHIP = 'to_ship',
    CLOSED = 'closed'
}

export const keyboard_ru = [
    'й', 'ц', 'у', 'к', 'е', 'н', 'г', 'ш', 'щ', 'з', 'х', 'ъ',
    'ф', 'ы', 'в', 'а', 'п', 'р', 'о', 'л', 'д', 'ж', 'э',
    'я', 'ч', 'с', 'м', 'и', 'т', 'ь', 'б', 'ю'
];

export const keyboard_en = [
    'q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', '[', ']',
    'a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', ';', '\'',
    'z', 'x', 'c', 'v', 'b', 'n', 'm', ',', '.'
];

export const enum VisibilityStates {
    VISIBLE_FOR_ALL = 'VisibleForAll',
    HIDDEN_FOR_SUPL_STORE = 'HiddenForSuplStore'
}

export const availabilityLabelMap = {
    [AvailabilityOptions.InStock]: 'text_availability_in_stock',
    [AvailabilityOptions.OutOfStock]: 'text_availability_out_stock',
    [AvailabilityOptions.NovaPoshta]: 'text_availability_np',
    [AvailabilityOptions.WillBeAvailableInDays]: 'text_availability_in_stock_later',
    [AvailabilityOptions.WillBeAvailableInDays + '1']: 'text_availability_in_stock_1day',
    [AvailabilityOptions.WillBeAvailableInDays + '2']: 'text_availability_in_stock_2days',
    [AvailabilityOptions.WillBeAvailableInDays + '3']: 'text_availability_in_stock_3days_plus'
};

export const availabilityOptions = [
    {
        label: 'text_availability_in_stock',
        value: {
            availability: AvailabilityOptions.InStock
        }
    },

    {
        label: 'text_availability_in_stock_1day',
        value: {
            availability: AvailabilityOptions.WillBeAvailableInDays,
            period: 1
        }
    },

    {
        label: 'text_availability_in_stock_2days',
        value: {
            availability: AvailabilityOptions.WillBeAvailableInDays,
            period: 2
        }
    },

    {
        label: 'text_availability_in_stock_3days_plus',
        value: {
            availability: AvailabilityOptions.WillBeAvailableInDays,
            period: 3
        }
    },

    {
        label: 'text_availability_np',
        value: {
            availability: AvailabilityOptions.NovaPoshta
        }
    },

    {
        label: 'text_availability_out_stock',
        value: {
            availability: AvailabilityOptions.OutOfStock
        }
    }
];

export const enum Measure {
    Liter = 'Liter',
    Kilogram = 'Kilogram',
    Meter = 'Meter',
    Piece = 'Piece',
    Set = 'Set',
    Package = 'Package',
    Canister = 'Canister'
}
